import { Messages } from '../../codegen/Localize';
import { FlowOutputStepRunStatus } from '../../ts/models/FlowOutputStepRunInfo';
import { RunFlowTaskStatus } from '../../ts/models/RunFlowTaskInfo';
import { OutputOperationType } from '../../ts/ServerApi/types/FlowOutputStep';

export function getOutputOperationTypeDisplayText(outputOperationType: OutputOperationType) {
  switch (outputOperationType) {
    case 'outputOperationTypeCreate':
      return Messages.writeOptionsCreate();
    case 'outputOperationTypeAppend':
      return Messages.writeOptionsAppend();
    case 'outputOperationTypeTruncate':
      return Messages.writeOptionsTruncate();
    default:
      return assertNeverHit(outputOperationType);
  }
}

export function getRefreshTypeDisplayText(isIncremental: Boolean, outputOperationType: OutputOperationType) {
  return (isIncremental ? Messages.writeOptionsIncremental() : Messages.writeOptionsFull());
}

export function getOutputOperationTypeHelpText(outputOperationType: OutputOperationType) {
  switch (outputOperationType) {
    case 'outputOperationTypeCreate':
      return Messages.writeOptionsCreateHelpText();
    case 'outputOperationTypeAppend':
      return Messages.writeOptionsAppendHelpText();
    case 'outputOperationTypeTruncate':
      return Messages.writeOptionsTruncateHelpText();
    default:
      return assertNeverHit(outputOperationType);
  }
}

function assertNeverHit(obj: never) {
  throw new Error(`Assert never hit was triggered with: ${obj}`);
}
